var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-promotion-form',{staticClass:"pt-promotion-form__page",attrs:{"id":_vm.id,"is-edit":_vm.is_edit,"isActive":_vm.is_active}})}
var staticRenderFns = []

export { render, staticRenderFns }